import React, { useEffect, useState } from "react";
import httpClient from "../../_util/api";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, TablePagination, TextField, IconButton, Button, Typography, Box
} from "@mui/material";
import { Edit, Delete, Visibility, Add } from "@mui/icons-material";
import ApplicationDetails from "./ApplicationDetails";

const UserTable = () => {
  const [data, setData] = useState([]);
  const [applicationData, setApplicationData] = useState([]);
  const [isViewDetails, setIsViewDetails] = useState(false);

  const getAllApplicationByCNICNo = async () => {
    try {
      const res = await httpClient.get(`/students/getStudentApplications`);
      if (res.status === 200) {
        setData(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAllApplicationByCNICNo();
  }, []);

  const hasInProcessApplication = data.some(
    (item) => item.status === 'pending' || item.status === 'process'
  );

  if(isViewDetails) {
    return (
      <ApplicationDetails data={applicationData}/>
    )
  }

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", padding: 2 }}>
      {hasInProcessApplication ? (
        <Typography color="error" sx={{ mb: 2 }}>
          Your application is already in process. You can apply again once it has been approved.
        </Typography>
      ) : (
        <Box
          sx={{
            backgroundColor: "#f1f8f2",
            border: "1px solid #4caf50",
            borderRadius: 1,
            padding: 1.5,
            mb: 2,
          }}
        >
          <Typography variant="body2">
            Applying for a new scholarship cycle requires a one-time application link. Please request one from
            your coordinator/admin — they'll send it to you to apply.
          </Typography>
        </Box>
      )}
      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: "#4caf50" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>#</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Application No</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Degree</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Enrollment #</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Institution</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Semester</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Tuition Fee</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Approved Fee</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Submission Date</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow 
                onClick={() => {
                  setApplicationData(data.find(e => e._id == item._id))
                  setIsViewDetails(true); 
                }} 
                key={item.id} 
                sx={{ cursor: "pointer" }}
              > 
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.applicationNumber}</TableCell>
                <TableCell>{item.degree || "-"}</TableCell>
                <TableCell>{item.enrollmentNo || "-"}</TableCell>
                <TableCell>{item.otherInstitutionName || item.institutionName}</TableCell>
                <TableCell>{item.grade}</TableCell>
                <TableCell>{item.tuttionFee}</TableCell>
                <TableCell>{item.approvedFee}</TableCell>
                <TableCell>{item.applicationSubmitDate}</TableCell>
                <TableCell
                  style={{
                    textTransform: 'capitalize',
                    color: item.status === 'rejected' ? 'red' : 'inherit'
                  }}
                >
                  {item.status}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default UserTable;
